// extracted by mini-css-extract-plugin
module.exports = {"menu":"button-menu_menu__B67R_","fade-in":"button-menu_fade-in__Z_FWz"};